module.exports = __webpack_public_path__ + "images/maquette1-2522ae4f16305169db09d2af79c71951.jpg";